import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTaxonomyService } from '@restworld/data-services';
export var useOccupationsByDomainInterest = function useOccupationsByDomainInterest(_ref) {
  var domainInterestId = _ref.domainInterestId,
      domainInterest = _ref.domainInterest;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState([]),
      occupationOptions = _useState2[0],
      setOccupationOptions = _useState2[1];

  var taxonomyService = useTaxonomyService();
  var occupationOptionsCp = useMemo(function () {
    return occupationOptions.map(function (v) {
      return {
        id: v.id.toString(),
        key: v.id.toString(),
        label: v.label_it.label,
        description: v.label_it.description
      };
    });
  }, [occupationOptions]);
  var getOccupationOptions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var domainInterestIdCp, findIndex, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (domainInterestId) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.prev = 2;
            domainInterestIdCp = '';
            findIndex = domainInterest.findIndex(function (v) {
              return v.id === domainInterestId;
            });
            if (findIndex > -1) domainInterestIdCp = String(domainInterest[findIndex]['id']);
            setLoading(true);
            _context.next = 9;
            return taxonomyService.indexOccupations(domainInterestIdCp);

          case 9:
            response = _context.sent;
            setOccupationOptions(response.data);
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            console.error("error fetching occupation", _context.t0);

          case 16:
            _context.prev = 16;
            setLoading(false);
            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 13, 16, 19]]);
  })), [domainInterest, domainInterestId, taxonomyService]);
  useEffect(function () {
    getOccupationOptions();
  }, [getOccupationOptions]);
  var returnV = useMemo(function () {
    return {
      loading: loading,
      occupationOptions: occupationOptionsCp
    };
  }, [loading, occupationOptionsCp]);
  return returnV;
};